export const FLAG_GETTING_MAINTENANCE_PLANNING_ACTIVITY_RESOURCES =
  'FLAG_GETTING_MAINTENANCE_PLANNING_ACTIVITY_RESOURCES';
export const GET_MAINTENANCE_PLANNING_ACTIVITY_RESOURCES =
  'GET_MAINTENANCE_PLANNING_ACTIVITY_RESOURCES';
export const CLEAR_MAINTENANCE_PLANNING_ACTIVITY_RESOURCES =
  'CLEAR_MAINTENANCE_PLANNING_ACTIVITY_RESOURCES';
